var React = require('react');

function IconLpClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.0004 10.657L6.34341 5L4.9292 6.41421L10.5862 12.0712L4.9293 17.728L6.34352 19.1422L12.0004 13.4854L17.6571 19.1421L19.0713 17.7279L13.4146 12.0712L19.0714 6.41431L17.6572 5.00009L12.0004 10.657Z","fill":"#001190"}));
}

IconLpClose.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"presentation","aria-hidden":"true","data-contrast":"svg-fill","className":"icon"};

module.exports = IconLpClose;

IconLpClose.default = IconLpClose;
